import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { MainService } from '../services/main.service';
import Swal from 'sweetalert2';
import { MainService as crudMain } from 'svm-crudui';

@Component({
  selector: 'app-hier',
  templateUrl: './hier.component.html',
  styleUrls: ['./hier.component.css']
})
export class HierComponent implements OnInit {

  constructor(public main: MainService, public crudMain: crudMain, private route: ActivatedRoute, private router: Router) { }

  async ngOnInit() {
    await this.getAllTerms()
    await this.getDefaultcodevalues()
  }
  termarr = []
  CL: any = {}
  data: any = {}
  listflag = true
  viewflag = false;
  addflag = false;
  updateflag = false;
  selectedTermId: any = {}
  async getAllTerms() {
    this.termarr = []
    let where: any = {
      "and": [
        {
          "di_tcd": {
            "=": "TR"
          }
        },

        {
          "di_tcd_json.cl_type.hier_init": {
            "!=": ""
          }
        },

      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,


    };
    try {

      const resp = await this.main.getListData(req_obj);
      if (!resp.error) {
        console.log(resp['data']);

        this.termarr = resp['data']

        this.selectedTermId = this.termarr[0]
        console.log(this.selectedTermId);

      } else {

        Swal.fire('Error!', 'Failed to get terms.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to get terms.', 'error');
    }
  }
  async getDefaultcodevalues() {
    if (this.selectedTermId) {
      await this.inputchange()
    }
  }
  async inputchange() {
    this.CL = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      code: 'PF',
      value: 'Hierarchy',

      cards: {
        mainHeading: 'cl_cd',
        subHeading: 'cl_val',
        imagePath: '../../assets/hier.png',
        actionAreaLeft: 'status_cd',
        actionAreaMid: 'captured_at'

      },
      crudconfig: {
        viewEvent: true,
        updateEvent: true
      }

    }
    let dummyinputobj = JSON.parse(JSON.stringify(this.CL))
    dummyinputobj.filters = {
      "and": [
        { "di_id": { "=": this.selectedTermId?.['di_id'] } },
        {
          "cl_tcd": {
            "=": "HIER"
          }
        }
      ]
    }
    this.CL = dummyinputobj

  }
  async onAddButtonClick() {
    this.reset()
    await this.setflag(false, false, true, false)
  }
  async setflag(v, u, a, l) {
    this.viewflag = v;
    this.addflag = a;
    this.updateflag = u;
    this.listflag = l
  }
  async submit() {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to Add the Hierarchy`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, add it!'
    });


    if (result.isConfirmed) {
      if (await this.validateForm()) {
        await this.inserthier(this.data)
      }
    }
  }
  async validateForm() {
    if ((this.data['cl_cd'] == undefined || this.data['cl_cd'] == null || this.data['cl_cd'] == "") || (this.data['cl_val'] == undefined || this.data['cl_val'] == null || this.data['cl_val'] == "")) {
      Swal.fire('Error!', `field required`, 'error');
      return false;
    }
    return true;
  }
  // async insertClassifications() {
  //   let classificationReqObj = {
  //     'pf_path': 'dd',
  //     'pf_name': 'cl',
  //     'app_cd': 'DD',
  //     columns: ["di_id", "cl_cd", "cl_val", "cl_desc", "cl_tcd", "cl_tcd_json"],
  //     values: []
  //   };
  //   classificationReqObj.values.push([
  //     this.selectedTermId['di_id'],
  //     this.data?.cl_cd,
  //     this.data?.cl_val,
  //     this.data?.cl_desc || null,
  //     'HIER',
  //     {}
  //   ])
  //   try {
  //     let resp = await this.main.addMultiData(classificationReqObj);
  //     if (!resp['error']) {
  //       await this.inputchange()
  //       await this.reset()
  //       await this.setflag(false, false, false, true)

  //       Swal.fire('Success!', 'Hierarchy added successfully.', 'success');

  //     } else {
  //       Swal.fire('Error!', 'Failed to add Hierarchy.', 'error');
  //     }
  //   } catch (error) {
  //     Swal.fire('Error!', 'Failed to add Hierarchy.', 'error');
  //   }
  // }
  async inserthier(data) {
    let columns = ['di_id', 'cl_cd', 'cl_tcd', 'cl_tcd_json'];

    let values = [this.selectedTermId['di_id'], data['cl_cd'], 'HIER', {}];


    if (data['cl_val']) {
      columns.push('cl_val');
      values.push(data['cl_val']);
    }
    if (data['cl_desc']) {
      columns.push('cl_desc');
      values.push(data['cl_desc']);
    }




    let req_obj = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      columns: columns,
      values: values
    };
    try {
      let resp = await this.main.addData(req_obj);

      if (!resp['error']) {
        await this.inputchange()
        await this.reset()
        await this.setflag(false, false, false, true)

        Swal.fire('Success!', 'Hierarchy added successfully.', 'success');

      } else {
        Swal.fire('Error!', 'Failed to add Hierarchy.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to add Hierarchy.', 'error');
    }
  }
  async reset() {
    this.data = {}
  }
  async onViewClicked(item: any) {
    let itemObj = window.btoa(JSON.stringify(item))

    this.router.navigate(['./hr-manage'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });

  }
  async onUpdateClicked(item: any) {
    console.log(item);
    await this.setDataOnUpdateorView(item)
    this.setflag(false, true, false, false)
  }
  clItem = {}
  async setDataOnUpdateorView(item: any) {
    this.clItem = item
    this.data = {}
    this.data['cl_cd'] = item['cl_cd']
    this.data['cl_val'] = item['cl_val']
    this.data['cl_desc'] = item['cl_desc']
  }
  gotolist() {
    this.setflag(false, false, false, true)
  }
  async update() {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to Update the Hierarchy`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Update it!'
    });


    if (result.isConfirmed) {
      if (await this.validateForm()) {
        await this.formatupdateobj()



      }
    }

  }
  async formatupdateobj() {
    let cl = {}
    cl['cl_cd'] = this.data['cl_cd']
    cl['cl_val'] = this.data['cl_val']
    cl['cl_desc'] = this.data['cl_desc']
    cl['cl_tcd'] = this.clItem['cl_tcd']
    cl['cl_tcd_json'] = this.clItem['cl_tcd_json']
    cl['cl_id'] = this.clItem['cl_id']
    await this.updatecl(cl)
  }
  async updatecl(cl: any) {

    let updateobj = {}
    updateobj['cl_cd'] = cl['cl_cd']
    updateobj['cl_val'] = cl['cl_val']
    updateobj['cl_desc'] = cl['cl_desc']
    updateobj['cl_tcd'] = cl['cl_tcd']
    updateobj['cl_tcd_json'] = cl['cl_tcd_json']

    let where: any = {}

    where['cl_id'] = cl['cl_id']

    this.main.updateData({ pf_path: 'dd', pf_name: 'cl', app_cd: 'DD', set: updateobj, where: where }).then(async response => {
      if (!response['error']) {
        Swal.fire('Success!', 'Hierarchy updated successfully.', 'success');
        await this.inputchange()
        await this.reset()
        await this.setflag(false, false, false, true)
      } else {
        Swal.fire('Error!', 'Failed to update  Hierarchy.', 'error');
      }
    }).catch(error => {
      Swal.fire('Error!', 'Failed to update  Hierarchy.', 'error');

    });


  }

}
